import { all, any, arrayLen, arrayOf, debug, is, number, Predicate } from '../checks';

export const isPosInf = is(Number.POSITIVE_INFINITY) as Predicate;
export const isNegInf = is(Number.NEGATIVE_INFINITY) as Predicate;
export const infNum = any(isPosInf, isNegInf, number) as Predicate;

export const pointTest = all(arrayLen(3), any(arrayOf(number), arrayOf(isPosInf), arrayOf(isNegInf))) as Predicate;

export const matrixTest = all(arrayLen(16), any(arrayOf(number), arrayOf(isPosInf), arrayOf(isNegInf))) as Predicate;
